import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-italic"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("line", {
      x1: "19",
      y1: "4",
      x2: "10",
      y2: "4"
    }, null, -1),
    _createElementVNode("line", {
      x1: "14",
      y1: "20",
      x2: "5",
      y2: "20"
    }, null, -1),
    _createElementVNode("line", {
      x1: "15",
      y1: "4",
      x2: "9",
      y2: "20"
    }, null, -1)
  ]))]))
}
export default { render: render }